/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import useLogout from '@/layouts/modules/logout';
import { useAppStore } from '@/store/modules/app';
import { useTaskStore } from '@/store/modules/downTask';
import { usePermissionStore } from '@/store/modules/permission';
import { UseGlobalConfig } from '@/utils/hooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'popularize',
  setup(__props) {
    const handleLogout = useLogout();
    const {
      setTask
    } = useTaskStore();
    const {
      btnPermissions
    } = usePermissionStore();
    // const urlBase = {
    // 	test: 'http://support-new.dev.yingxiong.com/',
    // 	development: 'http://localhost:8888/',
    // 	production: 'http://support-new.dev.yingxiong.com/',
    // };
    const appStore = useAppStore();
    const {
      $channel
    } = UseGlobalConfig();
    const url = process.env.VUE_APP_POPULARIZE_URL + 'popularize';
    const handleDataChange = e => {
      // console.log('来自子应用 popularize 的数据:', e.detail.data);
      const {
        type,
        data
      } = e.detail.data;
      if (type === 'loginExpired') {
        handleLogout();
      } else if (type === 'exportTable') {
        setTask(data);
        console.log('exportTable', data);
      } else if (type === 'commentKey') {
        appStore.commentKey = data;
      }
    };
    const getUserInfo = () => {
      let user = localStorage.getItem('user') || '';
      if (user) {
        user = JSON.parse(user);
        return {
          token: user.token,
          uid: user.uid
        };
      }
      return {
        token: '',
        uid: ''
      };
    };
    const officialChannel = [...$channel.INTERNAL, ...$channel.GLOBAL];
    const baseData = computed(() => {
      return {
        gameInfo: appStore.gameInfo,
        gameType: appStore.gameType,
        userInfo: getUserInfo(),
        btnPermissions,
        officialChannel
      };
    });
    let loading;
    const handleCreate = () => {
      loading = ElLoading.service({
        lock: false,
        text: 'Loading',
        background: 'transparent'
      });
    };
    const handleMounted = () => {
      loading.close();
    };
    return (_ctx, _cache) => {
      const _component_micro_app = _resolveComponent("micro-app");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_micro_app, {
        name: "popularize",
        url: url,
        data: _unref(baseData),
        onCreated: handleCreate,
        onMounted: handleMounted,
        baseroute: "/micro/popularize",
        onDatachange: handleDataChange
      }, null, 8, ["data"])]);
    };
  }
});